import {
  initialState,
  Actions,
  State,
  GET_POST_TIME_SERIES,
  GET_POST_TIME_SERIES_SUCCESS,
  GET_POST_TIME_SERIES_ERROR,
  RESET_POST_TIME_SERIES,
} from "../../types/post-views/get-time-series";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_POST_TIME_SERIES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_POST_TIME_SERIES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_POST_TIME_SERIES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_POST_TIME_SERIES:
      return initialState;
    default:
      return state;
  }
};

export default reducers;

